import React from 'react';

import { AboutPospSlider} from '../about-slider';

export const Payouts = () => {

  return (
    <div className="bg-primary">
      <div className="py-15 container grid grid-cols-1 items-start gap-[100px]  xl:grid-cols-2">
        <div className="flex flex-col gap-3">
          <div className="bg-secondary h-[5px] w-[50px] rounded-lg "></div>
          <h1 className="text-secondary text-title-7 md:text-title-6 lg:text-title-6 font-medium">
            POSP at PrishaPolicy
          </h1>
          <h1 className="text-title-4 font-bold text-white  md:text-[40px] lg:text-[40px]">Payouts</h1>
          <p className="text-body-3 md:text-title-6 lg:text-title-6 font-normal text-white ">
            These are sample rates and commissions are calculated on the based of standard IRDAI guidelines and may vary
            based on the business done.
          </p>
        </div>
        <div className="">
          <AboutPospSlider />
        </div>
      </div>
    </div>
  );
};
